import type {
    EmployeeProfileDropdownProps,
} from "../../contacts-search-profiles/components/EmployeeProfileDropdown/EmployeeProfileDropdown";
import EmployeeProfileDropdown from "../../contacts-search-profiles/components/EmployeeProfileDropdown/EmployeeProfileDropdown";

type DepartmentsDropdownProps = { onSelect(selectedIds: readonly string[]): void } & Omit<
    EmployeeProfileDropdownProps,
    "onAdd" | "onRemove" | "id"
>;

const DepartmentsDropdown = ({ onSelect, selectedIds = [], ...rest }: DepartmentsDropdownProps) => {
    function handleAdd(id: string) {
        onSelect(selectedIds.concat(id));
    }

    function handleRemove(id: string) {
        onSelect(selectedIds.filter((i) => i !== id));
    }

    return (
        <EmployeeProfileDropdown
            {...rest}
            id="department"
            onAdd={handleAdd}
            onRemove={handleRemove}
            selectedIds={selectedIds}
            emptyButtonText={{
                key: "si.account-overview.employee-profiles.departments-dd.button-text",
            }}
        />
    );
}

export default DepartmentsDropdown;
